import { Component, createApp } from 'vue';
import './style.css';
import App from './App.vue';
import Antd from 'ant-design-vue';
import router from '@/router';
import { createPinia } from 'pinia';
import 'ant-design-vue/dist/reset.css';
import * as Icons from '@ant-design/icons-vue';
import adminDir from '@/directives/admin-directive';
import linuxAdminDir from '@/directives/linux-admin-directive';
import forkliftPermissionDir from '@/directives/forklift-permission-directive';
import * as Sentry from '@sentry/vue';
import persistedState from 'pinia-plugin-persistedstate';

const app = createApp(App);

// 注册图标组件
for (const i in Icons) {
  app.component(i, (Icons as Record<string, Component>)[i]);
}

app.directive('admin', adminDir);
app.directive('linux-admin', linuxAdminDir);
app.directive('forklift-permission', forkliftPermissionDir);

Sentry.init({
  app,
  dsn: 'https://c6e711a23aa11f02016d20a7c9616833@sentry.systech.com.cn/8',
});

const pinia = createPinia();

pinia.use(persistedState);

app.use(pinia).use(router).use(Antd).mount('#app');
